import React from 'react';
import { motion } from 'framer-motion';
import { Video, Users, Mic, Activity, CheckCircle2, Smartphone } from 'lucide-react';
const captureItems = [{
  icon: Mic,
  text: 'Leadership micro-interviews'
}, {
  icon: Users,
  text: 'Employee reactions'
}, {
  icon: Video,
  text: 'Booth footage & atmosphere'
}];
const activateItems = [{
  icon: Activity,
  text: 'Live polls & peer sentiment'
}, {
  icon: CheckCircle2,
  text: 'Prediction quizzes'
}, {
  icon: Smartphone,
  text: 'Participation moments'
}];
export const Slide05ERA = () => {
  return <div className="relative w-full h-full flex flex-col justify-center px-24 bg-slate-950 overflow-hidden" data-id="element-94">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950" data-id="element-95" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="relative z-10 text-center mb-16" data-id="element-96">
        <h2 className="text-5xl font-bold tracking-tight text-white mb-4" data-id="element-97">
          Capture the energy.{' '}
          <span className="text-red-500" data-id="element-98">Activate the organization.</span>
        </h2>
      </motion.div>

      <div className="relative z-10 grid grid-cols-2 gap-16 max-w-6xl mx-auto w-full" data-id="element-99">
        {/* LEFT: CAPTURE */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="bg-slate-900/40 border border-slate-800 rounded-3xl p-10 relative overflow-hidden" data-id="element-100">
          <div className="absolute top-0 left-0 w-full h-1 bg-slate-700" data-id="element-101" />
          <h3 className="text-3xl font-bold text-white mb-8 flex items-center" data-id="element-102">
            <span className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center mr-4 text-sm text-slate-300" data-id="element-103">
              1
            </span>
            CAPTURE
          </h3>

          <div className="space-y-6" data-id="element-104">
            {captureItems.map((item, i) => <div key={i} className="flex items-center space-x-4" data-id="element-105">
                <div className="w-12 h-12 rounded-full bg-slate-800/50 flex items-center justify-center border border-slate-700" data-id="element-106">
                  <item.icon className="w-5 h-5 text-slate-400" data-id="element-107" />
                </div>
                <span className="text-xl text-slate-300 font-light" data-id="element-108">
                  {item.text}
                </span>
              </div>)}
          </div>

          {/* Mock Video Frame */}
          <div className="mt-10 w-full h-40 bg-slate-950 rounded-xl border border-slate-800 relative overflow-hidden group" data-id="element-109">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1540317580384-e5d43867caa6?q=80&w=1000&auto=format&fit=crop')] bg-cover bg-center opacity-40 mix-blend-luminosity" data-id="element-110" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-111">
              <div className="w-12 h-12 rounded-full bg-red-600/80 flex items-center justify-center backdrop-blur-sm group-hover:scale-110 transition-transform" data-id="element-112">
                <div className="w-0 h-0 border-t-[6px] border-t-transparent border-l-[10px] border-l-white border-b-[6px] border-b-transparent ml-1" data-id="element-113" />
              </div>
            </div>
          </div>
        </motion.div>

        {/* RIGHT: ACTIVATE */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="bg-gradient-to-br from-red-950/40 to-slate-900/40 border border-red-900/30 rounded-3xl p-10 relative overflow-hidden shadow-[0_0_40px_rgba(220,38,38,0.05)]" data-id="element-114">
          <div className="absolute top-0 left-0 w-full h-1 bg-red-600" data-id="element-115" />
          <h3 className="text-3xl font-bold text-white mb-8 flex items-center" data-id="element-116">
            <span className="w-8 h-8 rounded-full bg-red-900/50 flex items-center justify-center mr-4 text-sm text-red-400" data-id="element-117">
              2
            </span>
            ACTIVATE
          </h3>

          <div className="space-y-6" data-id="element-118">
            {activateItems.map((item, i) => <div key={i} className="flex items-center space-x-4" data-id="element-119">
                <div className="w-12 h-12 rounded-full bg-red-950/50 flex items-center justify-center border border-red-900/50" data-id="element-120">
                  <item.icon className="w-5 h-5 text-red-400" data-id="element-121" />
                </div>
                <span className="text-xl text-slate-300 font-light" data-id="element-122">
                  {item.text}
                </span>
              </div>)}
          </div>

          {/* Mock Interactive UI */}
          <div className="mt-10 w-full bg-slate-950/80 rounded-xl border border-slate-800 p-6 backdrop-blur-md" data-id="element-123">
            <p className="text-sm text-slate-400 mb-4 font-medium" data-id="element-124">
              "What do you think colleagues feel right now?"
            </p>
            <div className="space-y-3" data-id="element-125">
              <div className="w-full h-10 bg-slate-900 rounded-lg border border-slate-700 flex items-center px-4 relative overflow-hidden" data-id="element-126">
                <div className="absolute left-0 top-0 h-full bg-red-600/20 w-[65%]" data-id="element-127" />
                <span className="relative z-10 text-sm text-white" data-id="element-128">
                  Inspired & Ready
                </span>
                <span className="relative z-10 ml-auto text-sm text-slate-400" data-id="element-129">
                  65%
                </span>
              </div>
              <div className="w-full h-10 bg-slate-900 rounded-lg border border-slate-700 flex items-center px-4 relative overflow-hidden" data-id="element-130">
                <div className="absolute left-0 top-0 h-full bg-slate-800 w-[35%]" data-id="element-131" />
                <span className="relative z-10 text-sm text-white" data-id="element-132">
                  Cautiously Optimistic
                </span>
                <span className="relative z-10 ml-auto text-sm text-slate-400" data-id="element-133">
                  35%
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
};